import { Flex } from "antd";
import { Link } from "react-router";
import BangladeshFlag from "../../../assets/images/nationalFlag/bangladeshFlag.svg";
import WhiteLogo from "../../../assets/images/WhiteLogo.svg";
import FacebookCircleIcon from "../_icons/FacebookCircleIcon";
import LinkedInCircleIcon from "../_icons/LinkedInCircleIcon";
import LocationIcon from "../_icons/LocationIcon";
import MailIcon from "../_icons/MailIcon";
import TelephoneIcon from "../_icons/TelephoneIcon";
import YoutubeCircleIcon from "../_icons/YoutubeCircleIcon";
import Img1 from "/images/logo/1.svg";
import Img2 from "/images/logo/2.svg";

export default function Footer({ isPlatform = false }) {
  return (
    <footer
      className={`bg-[#0B0F14] ${isPlatform ? "pt-24 relative z-0" : "pt-6"}`}
    >
      <div className="px-5 lg:px-16">
        <div className="pb-14 mt-10">
          {/* Main Grid */}
          <div className="pb-10">
            <div className="text-white text-base font-medium font-roboto leading-7 mb-4">
              In Association With
            </div>
            <Flex align="start" wrap gap={40}>
              <img className="size-[70px]  object-cover" src={Img1} alt="" />
              <img className="size-14  object-cover" src={Img2} alt="" />
            </Flex>
          </div>

          <div className="grid grid-cols-12 gap-8 lg:gap-16 lg:items-start">
            <div className="col-span-12 md:col-span-12 lg:col-span-4">
              {/* <Flex align="center" gap={8}>
                <Image
                  className="size-20 rounded-full object-cover"
                  src={Logo1}
                  alt=""
                  width={100}
                  height={100}
                />
                <Image
                  className="size-20 rounded-full object-cover"
                  src={Logo2}
                  alt=""
                  width={100}
                  height={100}
                />
              </Flex> */}
              <div className="flex  items-center gap-3">
                <img
                  src={BangladeshFlag}
                  alt="manPowerX"
                  className="h-8 sm:h-10"
                />
                <img src={WhiteLogo} alt="manPowerX" className="h-10 sm:h-12" />
              </div>

              <div className="text-theme-white-900 text-sm font-normal mt-3 sm:mt-4">
                আমাদের প্ল্যাটফর্ম বাংলাদেশের দক্ষ জনশক্তিকে বিদেশি চাকরির
                সুযোগের সাথে যুক্ত করে। স্কি
                <span className="opacity-0 absolute">.</span>ল ডেভেলপমেন্ট,
                ট্রেনিং ও বিশ্বস্ত রিক্রুটমেন্ট এজেন্সির মাধ্যমে নিরাপদ বিদেশি
                কর্মসংস্থান নিশ্চিত করা আমাদের লক্ষ্য।
              </div>
              <p className="text-theme-white-900 text-sm font-normal mt-3">
                Powered by UpscaleBD Limited
              </p>

              <p className="text-theme-white-900 text-sm font-normal mt-3">
                ট্রেড লাইসেন্স নম্বরঃ TRAD/DSCC/025220/2022
              </p>
            </div>

            <div className="col-span-12 lg:col-span-8">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div>
                  <div className="text-theme-white-900 text-base lg:text-xl font-medium mb-4">
                    দ্রুত লিংকসমূহ
                  </div>
                  <ul className="space-y-2 text-sm text-gray-400">
                    <li>
                      <Link
                        to="/"
                        className=" text-theme-white-900 text-sm lg:text-base font-normal hover:!text-theme-primary"
                      >
                        হোম
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/courses"
                        className=" text-theme-white-900 text-sm lg:text-base font-normal hover:!text-theme-primary"
                      >
                        কোর্সসমূহ
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/jobs"
                        className=" text-theme-white-900 text-sm lg:text-base font-normal hover:!text-theme-primary"
                      >
                        চাকরির তালিকা
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/success-story"
                        className=" text-theme-white-900 text-sm lg:text-base font-normal hover:!text-theme-primary"
                      >
                        সফলতার গল্প
                      </Link>
                    </li>
                  </ul>
                </div>

                <div>
                  <div className="text-theme-white-900 text-base lg:text-xl font-medium mb-4">
                    সাহায্য ও সাপোর্ট
                  </div>
                  <ul className="space-y-2 text-sm text-gray-400">
                    <li>
                      <a
                        href="https://upscalebd.com/privacy-policy"
                        target="_blank"
                        className=" text-theme-white-900 text-sm lg:text-base font-normal hover:!text-theme-primary"
                      >
                        প্রাইভেসি পলিসি
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://upscalebd.com/privacy-policy"
                        target="_blank"
                        className=" text-theme-white-900 text-sm lg:text-base font-normal hover:!text-theme-primary"
                      >
                        শর্তাবলী
                      </a>
                    </li>
                    <li>
                      <Link
                        to="/about-us"
                        className=" text-theme-white-900 text-sm lg:text-base font-normal hover:!text-theme-primary"
                      >
                        আমাদের সম্পর্কে
                      </Link>
                    </li>
                    <li>
                      <a
                        href="https://upscalebd.com/refund-policy"
                        target="_blank"
                        className=" text-theme-white-900 text-sm lg:text-base font-normal hover:!text-theme-primary"
                      >
                        রিফান্ড নীতিমালা
                      </a>
                    </li>
                    <li>
                      <Link
                        to="/faq"
                        className=" text-theme-white-900 text-sm lg:text-base font-normal hover:!text-theme-primary"
                      >
                        সাধারণ প্রশ্নোত্তর (FAQ)
                      </Link>
                    </li>

                    {/* <li>
                      <Link
                        to=""
                        className=" text-theme-white-900 text-sm lg:text-base font-normal hover:!text-theme-primary"
                      >
                        হেল্প সেন্টার
                      </Link>
                    </li> */}
                  </ul>
                </div>

                <div>
                  <div className="text-theme-white-900 text-base lg:text-xl font-medium mb-4">
                    যোগাযোগের ঠিকানা
                  </div>

                  <ul className="space-y-3 text-sm text-gray-400">
                    <li className="flex items-start gap-3">
                      <LocationIcon className="text-theme-white-900text-sm lg:text-base mt-0 lg:mt-1 shrink-0" />
                      <p className="text-theme-white-900 text-sm lg:text-base font-normal">
                        {/* ৬২/সি, গ্রিন রোড, ঢাকা,-১২০৫ */}
                        হাউস-২৫, রোড-৫, ব্লক-জে, বনশ্রী, রামপুরা, ঢাকা-১২১৯
                      </p>
                    </li>

                    <li className="flex items-start gap-3">
                      <TelephoneIcon className="text-theme-white-900 text-sm lg:text-base mt-0 lg:mt-1 shrink-0" />
                      <a
                        href="tel:01611090323"
                        className="text-theme-white-900 text-sm lg:text-base font-normal"
                      >
                        ০১৬১১-০৯০৩২৩
                      </a>
                    </li>

                    <li className="flex items-start gap-3">
                      <MailIcon className="text-theme-white-900 text-sm lg:text-base mt-0 lg:mt-1 shrink-0" />
                      <a
                        href="mailto:manpowerx.org@gmail.com"
                        className="text-theme-white-900 text-sm lg:text-base font-normal"
                      >
                        manpowerx.org@gmail.com
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pb-8">
          <img
            className="w-full hidden md:block"
            src="/images/payment-banner.png"
            alt=""
          />
          <img
            className="w-full md:hidden"
            src="/images/payment-banner-sm.png"
            alt=""
          />
        </div>

        <div className="border-t border-theme-gray-700">
          <div className="py-4 text-sm text-gray-500 flex flex-col md:flex-row gap-3 justify-between items-center">
            <div className="justify-start text-slate-100 text-sm lg:text-base font-normal font-roboto">
              © {new Date().getFullYear()} UpscaleBD LTD. All rights reserved.
            </div>
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/company/upscalebd-ltd/  "
                target="_blank"
              >
                <LinkedInCircleIcon className="text-[#3D4A5C] hover:!text-theme-primary" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61576860683385"
                target="_blank"
              >
                <FacebookCircleIcon className="text-[#3D4A5C] hover:!text-theme-primary" />
              </a>
              <a href="https://www.youtube.com/@UpscaleBD" target="_blank">
                <YoutubeCircleIcon className="text-[#3D4A5C] hover:!text-theme-primary" />
              </a>
              {/* <a
                href="https://play.google.com/store/apps/developer?id=UpscaleBD&hl=en"
                target="_blank"
              >
                <XCircleIcon className="text-[#3D4A5C] hover:!text-theme-primary" />
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
